// icons/providers/lucide.tsx

import * as React from 'react';
import type { IconToken } from '../types';
import { Magnet, Accessibility, Info, AlertCircle, CheckCircle2, RotateCcw, Waves, Snowflake, Flame, Boxes, Clock, PlayCircle, CheckCheck, XCircle } from 'lucide-react';


type LucideMap = Partial<Record<IconToken, React.FC<React.SVGProps<SVGSVGElement>>>>;

export const LUCIDE_MAP: LucideMap = {
  magnet: Magnet,
  accessibility: Accessibility,
  info: Info,
  error: AlertCircle,
  check: CheckCircle2,
  checkcircle2: CheckCircle2,
  clock: Clock,
  playcircle: PlayCircle,
  checkcheck: CheckCheck,
  xcircle: XCircle,
  rotateccw: RotateCcw,
  waves: Waves,
  snowflake: Snowflake,
  flame: Flame,
  boxes: Boxes,

  default: Info,
};
